import { getSectionFromFormType } from 'helpers/form';
import { RootActions } from 'types/state';
import { SF86 } from 'constants/formTypes';
import * as ActionTypes from './actionTypes';
import { RootActionTypes } from '../actionTypes';

export interface SectionState {
  section: SectionConfig
  subsection: SubsectionConfig
}

export interface SectionConfig {
  key: string | null
  name: string | null
  path: string | null
  store: string | null
  label: string | null
  subsections: SubsectionConfig[]
  displayErrorsReviewOnly?: string[]
}

export interface SubsectionConfig {
  key: string | null
  /** This will be the path of the section. While the path
   *  may be "membership-overthrow", this would be
   *  "associations/membership-overthrow". */
  name: string | null
  /** This will just be the path of the section. While the
   *  name may be "associations/membership-overthrow", this
   *  will be "membership-overthrow". */
  path: string | null
  storeKey?: string | null
  label: string | null
  /** Some subsections can have child subsections, such as
   * "relationships/status/marital." */
  subsections?: SubsectionConfig[]
}

export const initialState: SectionState = {
  section: getSectionFromFormType(SF86, { key: 'IDENTIFICATION' }),
  subsection: {
    key: null,
    name: null,
    label: null,
    path: null,
    storeKey: null,
  },
};

const section = (state: SectionState = initialState, action: RootActions) => {
  switch (action.type) {
    case ActionTypes.UPDATE_SECTION_SUCCESS:
      // We override the entire section/subsection intentionally. We don't need
      // to preserve any properties at this time, as the entire state object
      // changes.
      return {
        section: {
          ...action.payload.section,
          subsections: [...action.payload.section.subsections.map((s) => ({ ...s }))],
        },
        subsection: { ...action.payload.subsection },
      };
    // This shouldn't fail. In the scenario it does, there is a bug with the
    // code.
    case ActionTypes.UPDATE_SECTION_FAILURE:
      return {
        ...state,
        error: {
          ...action.payload,
        },
      };

    case RootActionTypes.authentication.LOGGED_OFF:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default section;
